module.exports = __webpack_public_path__ + "img/jsfnd3.03d16974.png";